export default __webpack_public_path__ + "static/media/logo-colored.6be52158.svg";